import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import update from "@beeldit/core/services/update";
import { DetailsActionContext } from "../details/DetailsActionContext";

function useUpdateSection() {

  const errorHandler = useErrorHandler();

  const {
    element: page,
    setBackendFormErrors: setBackendFormErrors,
    setSavingSection
  } = useContext(DetailsActionContext);

  return (pageId: any, sectionId: any, section: any, onSuccess: any) => {
    setSavingSection(sectionId);
    update(`pages/${pageId}/sections`, sectionId, section)
      .then((response: any) => {
        setSavingSection("");
        onSuccess(response.data);
        setBackendFormErrors({});
      })
      .catch((error: any) => {
        // errors.response.data contiene una variable errors que es un objeto donde la key debería ser sections.{index}.content.elements...
        // Sin embargo en errors viene un objeto con key que  es content.elements... por lo que tenemos que cambiar la key
        // Primero tenemos que saber el indice del section dentro del page
        setSavingSection("");
        // El remapeo solo se aplica cuando el error trae de verdad un cuerpo de validación.
        // Un 500 (por ejemplo al agotarse el tiempo de ejecución guardando una galería con
        // muchas imágenes) o una caída sin respuesta no lo traen, y acceder a
        // error.response.data.errors a ciegas lanzaba un TypeError dentro de este catch:
        const validationErrors = error?.response?.data?.errors;
        const sectionIndex =
          page?.sections?.findIndex((s: any) => s.id == sectionId) ?? -1;
        if (
          validationErrors &&
          typeof validationErrors === "object" &&
          sectionIndex >= 0
        ) {
          let newErrors: any = {};
          for (let key in validationErrors) {
            let newKey = key.replace("content", `sections.${sectionIndex}.content`);
            newErrors[newKey] = validationErrors[key];
          }
          error.response.data.errors = newErrors;
        }
        errorHandler(error, setBackendFormErrors);
      });
  };
}

export default useUpdateSection;
